export class AppConstants {
	/**
	 * The name that is used for the returnUrl queryParam
	 */
	static RETURN_URL = 'returnUrl';
}
